
import { Form, Input, Button, message } from 'antd';
import Particles from 'react-particles-js';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import cookie from "react-cookies"
import { Redirect } from "react-router-dom"
import "./login.less";
import { reqLogin } from "../../api"
import store from "../../utils/storeUtils"
import SITE from '../../config/siteConfig';
import logo from "../../assets/images/logo.png"
const Login = (props) => {

    const onFinish = async (values) => {
        const { username, password } = values
        const response = await reqLogin(username, password)
        if (response.data.result === 1) {
            message.success("登录成功")
            props.history.replace("/")
            store.saveCompanyInfo({ parent: response.data.parent, company_account: username, company_name: response.data.company_name })
        } else {
            message.error(response.data.err_msg)
        }
    };
    //如果cookie已经存在 直接进入admin 实现自动登录
    if (cookie.load(".SCAUTH")) {
        return <Redirect to="/"></Redirect>
    }
    return (
        <div className="login">
            <Particles
                params={{
                    "particles": {
                        "number": {
                            "value": 30
                        },
                        "size": {
                            "value": 3
                        },
                        'links': {
                            "distance": 300,
                            "color": "#ccc",
                            "opacity": 0.4
                        },
                        "color": {

                        },
                        "move": {
                            "speed": 1
                        },
                        "size": {
                            "random": true,
                            "minimumValue": 1,
                            "value": 16
                        }
                    },
                    "interactivity": {
                        "events": {
                            "onhover": {
                                "enable": true,
                                "mode": "repulse"
                            }
                        }
                    }
                }} />
            <section className="login-box">
                <div className="logo">
                    {/* <img src={logo} /> */}
                    <h1>{SITE.TITLE}</h1>
                </div>
                <Form
                    name="normal_login"
                    className="login-form"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: '请输入用户名!' }]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="请输入账号" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: '请输入密码' }]}
                    >
                        <Input
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="请输入密码"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">登录 </Button>
                    </Form.Item>
                </Form>
            </section>
        </div>
    )
}
export default Login